import React from "react";
import { useTranslation } from "react-i18next";
import SecondAccount from "./secondAccounts";
import { Root, Tittle } from "./style";

const Approvals = () => {
  const { t } = useTranslation();

  return (
    <Root>
      <SecondAccount />
    </Root>
  );
};

export default Approvals;
